import { IconButton, Stack, TableCell, TableRow } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../selectField';
import TextField from '../textField';
import BooleanField from '../booleanField';
import NumberField from '../numberField';

type Props = {
  settingNames: any[];
  condition?: any;
  error?: string;
  onAdd: (condition: any) => void;
  onDelete: (condition: any) => void;
  onCancelAdd: () => void;
};

const SettingCondition = ({ settingNames = [], condition, onAdd, onDelete, onCancelAdd }: Props) => {
  const { t } = useTranslation();

  const [settingName, setSettingName] = useState<any>(condition?.settingName);
  const [settingType, setSettingType] = useState<any>(
    settingNames.find((sn) => sn.name === condition?.settingName)?.type,
  );
  const [settingValue, setSettingValue] = useState<any>(condition?.settingValue);

  const [errors, setErrors] = useState<any>({});

  const onSettingNameChange = (newName: string) => {
    const found = settingNames.find((sn) => sn.name === newName);
    setSettingType(found?.type);
    setSettingName(newName);
  };

  const cancelAdd = () => {
    onCancelAdd();
  };

  const addCondition = () => {
    let hasError = false;
    const errs: any = {};
    if (!settingName) {
      errs.settingName = t('common.errors.requiredField');
      hasError = true;
    }

    if (settingType === 'b' || settingType === 'n') {
      if (settingValue === undefined || settingValue === '') {
        errs.settingValue = t('common.errors.requiredField');
        hasError = true;
      }
    } else if (!settingValue) {
      errs.settingValue = t('common.errors.requiredField');
      hasError = true;
    }

    setErrors(errs);
    if (!hasError) {
      onAdd({
        settingName,
        settingValue,
      });
    }
  };

  const deleteCondition = () => {
    onDelete(condition);
  };

  return (
    <>
      {condition ? (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
          <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>{condition.settingName}</TableCell>
          <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>{'' + condition.settingValue}</TableCell>
          <TableCell align="right">
            <IconButton size="small" onClick={() => deleteCondition()} color="error">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </TableCell>
        </TableRow>
      ) : (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
          <TableCell>
            <SelectField
              required
              options={settingNames.map((s) => s.name)}
              value={settingName}
              autoFocus
              onChange={onSettingNameChange}
              error={errors.settingName}
              fullWidth={true}
            />
          </TableCell>
          <TableCell>
            {(settingType === 's' ||
              settingType === 'l' ||
              settingType === 't' ||
              settingType === 'cron' ||
              settingType === 'regex') && (
              <TextField
                required
                value={settingValue}
                onChange={setSettingValue}
                error={errors.settingValue}
                fullWidth
              />
            )}
            {settingType === 'b' && (
              <BooleanField required value={settingValue} onChange={setSettingValue} error={errors.settingValue} />
            )}
            {settingType === 'n' && (
              <NumberField required value={settingValue} onChange={setSettingValue} error={errors.settingValue} />
            )}
          </TableCell>
          <TableCell align="right">
            <Stack direction="row" spacing={0.5} justifyContent="flex-end">
              <IconButton size="small" onClick={addCondition} color="primary">
                <CheckIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={() => cancelAdd()}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </Stack>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default SettingCondition;
